export default __webpack_public_path__ + "static/media/CrossMarkIcon.3c9815ee.svg";